import { ActionBarItem } from '@workwave-tidal/core/components/ActionBar'
import { Close } from '@workwave-tidal/core/icons'
import { ModalHeader } from '@/components/Modal'

import { useController } from '../../hooks/useController'
import { useTexts } from './useTexts'

export function Header() {
  const {
    close,
    data: { goingToEnable },
  } = useController()

  const texts = useTexts()

  return (
    <ModalHeader
      subtitle={texts.subtitle(goingToEnable)}
      title={texts.title}
      actions={[<ActionBarItem icon={<Close />} key="close" onClick={close} label="" />]}
    />
  )
}
